import { get, post, put, putRaw } from "./api_helper";

export const BUSINESS_URL = {
    getBusinesses : (filter) => post(`${process.env.REACT_APP_BACKEND}/Business/filter`, filter),
    getBusiness : (data) => get(`${process.env.REACT_APP_BACKEND}/Business/${data}`),
    postBusiness : (body) => post(`${process.env.REACT_APP_BACKEND}/Business/`, body),
    putBusiness : (body) => put(`${process.env.REACT_APP_BACKEND}/Business/`, body),
    getBusinessAll : () => get(`${process.env.REACT_APP_BACKEND}/Business/getAll`), 
}

export const USER_URL = {
    getUserLista : (filter) => post(`${process.env.REACT_APP_BACKEND}/User/filter`, filter),
    getUser : (data) => get(`${process.env.REACT_APP_BACKEND}/User/${data}`),
    getUserDropDown : () => get(`${process.env.REACT_APP_BACKEND}/User/getDropDown`),
    postUser : (body) => post(`${process.env.REACT_APP_BACKEND}/User/add`, body),
    putUser : (body) => put(`${process.env.REACT_APP_BACKEND}/User/update`, body),
    getUserAuthenticate : () => get(`${process.env.REACT_APP_BACKEND}/User/Authenticate`)
}

export const LOGO_URL = {
    getLogos : (filter) => post(`${process.env.REACT_APP_BACKEND}/Logo/filter`, filter),
    getLogo : (data) => get(`${process.env.REACT_APP_BACKEND}/Logo/${data}`),
    postLogo : (body) => post(`${process.env.REACT_APP_BACKEND}/Logo/`, body),
    putLogo : (body) => put(`${process.env.REACT_APP_BACKEND}/Logo/`, body),
    getLogoHistory : (data) => get(`${process.env.REACT_APP_BACKEND}/Logo/getHistory/${data}`),
    getLogoHistoryList : (data, page) => get(`${process.env.REACT_APP_BACKEND}/Logo/getHistory/${data}/10/${page}`),
    getLogoAll : () => get(`${process.env.REACT_APP_BACKEND}/Logo/getAll`),
}

export const REGIONS_URL = {
    getRegionsLista : (filter) => post(`${process.env.REACT_APP_BACKEND}/Region/filter`, filter),
    getRegion : (data) => get(`${process.env.REACT_APP_BACKEND}/Region/${data}`),
    postRegion : (body) => post(`${process.env.REACT_APP_BACKEND}/Region`, body),
    putRegion : (body) => put(`${process.env.REACT_APP_BACKEND}/Region`, body),
    getRegionAll : () => get(`${process.env.REACT_APP_BACKEND}/Region/getAll`),
}

export const STYLES_URL = {
    getStyle: (data) => get(`${process.env.REACT_APP_BACKEND}/Style/${data}`),
    getStyleAll: () => get(`${process.env.REACT_APP_BACKEND}/Style/getAll`),
    getStylesByType: (data) => get(`${process.env.REACT_APP_BACKEND}/Style/getbyType/${data}`),
    getStyleHistory: (data) => get(`${process.env.REACT_APP_BACKEND}/Style/getHistory/${data}`),
    getStyleHistoryList: (data, page) => get(`${process.env.REACT_APP_BACKEND}/Style/getHistory/${data}/10/${page}`),
    getStyles: (filter) => post(`${process.env.REACT_APP_BACKEND}/Style/filter`, filter),
    postStyle: (body) => post(`${process.env.REACT_APP_BACKEND}/Style`, body),
    putStyle: (body) => put(`${process.env.REACT_APP_BACKEND}/Style`, body),
}

export const TEMPLATE_URL = {
    getTemplateLista : (filter) => post(`${process.env.REACT_APP_BACKEND}/Template/filter`, filter),
    getTemplate : (data) => get(`${process.env.REACT_APP_BACKEND}/Template/${data}`),
    postTemplate : (body) => post(`${process.env.REACT_APP_BACKEND}/Template/`, body),
    putTemplate : (body) => put(`${process.env.REACT_APP_BACKEND}/Template/`, body),
    getTemplateHistory : (data) => get(`${process.env.REACT_APP_BACKEND}/Template/getHistory/${data}`),
    getTemplateHistoryList : (data, page) => get(`${process.env.REACT_APP_BACKEND}/Template/getHistory/${data}/10/${page}`),
    getTemplateAll : () => get(`${process.env.REACT_APP_BACKEND}/Template/getAll`),
}

export const SECTION_URL = {
    getSectionLista : (filter, config) => post(`${process.env.REACT_APP_BACKEND}/Section/filter`, filter, config),
    getSection: (data) => get(`${process.env.REACT_APP_BACKEND}/Section/${data}`),
    postSection : (body) => post(`${process.env.REACT_APP_BACKEND}/Section/`, body),
    putSection : (body) => put(`${process.env.REACT_APP_BACKEND}/Section/`, body),
    postSectionDuplicate : (idSection) => post(`${process.env.REACT_APP_BACKEND}/Section/duplicate?id=${idSection}`),
    getSectionHistory : (data) => get(`${process.env.REACT_APP_BACKEND}/Section/getHistory/${data}`),
    getSectionHistoryList : (data, page) => get(`${process.env.REACT_APP_BACKEND}/Section/getHistory/${data}/10/${page}`),
    getSectionAll: () => get(`${process.env.REACT_APP_BACKEND}/Section/getAll`),
    getSectionProducts : (data) => get(`${process.env.REACT_APP_BACKEND}/Section/getproducts/${data}`),
    getSectionSnippets : (data) => get(`${process.env.REACT_APP_BACKEND}/Section/getsnippets/${data}`),
    getSectionPreview : (data) => get(`${process.env.REACT_APP_BACKEND}/Section/preview/${data}`),

    postSectionDownloadList : (body) => post(`${process.env.REACT_APP_BACKEND}/Section/export`, body),
}

export const DOCUMENT_URL = {
    getDocumentLista : (filter, config) => post(`${process.env.REACT_APP_BACKEND}/Document/filter`, filter, config),
    getDocument: (data) => get(`${process.env.REACT_APP_BACKEND}/Document/${data}`),
    postDocument : (body) => post(`${process.env.REACT_APP_BACKEND}/Document/`, body),
    putDocument : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/`, body),
    postDocumentDuplicate : (idDocument) => post(`${process.env.REACT_APP_BACKEND}/Document/duplicate?idDocument=${idDocument}`),
    getDocumentHistory : (data) => get(`${process.env.REACT_APP_BACKEND}/Document/getHistory/${data}`),
    getDocumentHistoryList : (documentId, page) => get(`${process.env.REACT_APP_BACKEND}/Document/getHistory/${documentId}/10/${page}`),
    getDocumentAll: () => get(`${process.env.REACT_APP_BACKEND}/Document/getAll`),
    getDocumentProducts : (data) => get(`${process.env.REACT_APP_BACKEND}/Document/getproducts/${data}`),
    getDocumentSnippets : (data) => get(`${process.env.REACT_APP_BACKEND}/Document/getsnippets/${data}`),
    getDocumentSections : (data) => get(`${process.env.REACT_APP_BACKEND}/Document/getsections/${data}`),
    getDocumentPreview : (data) => get(`${process.env.REACT_APP_BACKEND}/Document/preview/${data}`),
    putDocumentSaveAndSendToReview : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/updateandsendreview`, body),
    putDocumentReview : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/review/${body}`),
    putDocumentApproved : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/approved/${body}`),
    putDocumentReject : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/reject/${body}`),
    putDocumentPublish : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/publish/${body}`),
    putDocumentObsolete : (body) => put(`${process.env.REACT_APP_BACKEND}/Document/obsolete/${body}`),
    getDocumentDownload : (data, type) => get(`${process.env.REACT_APP_BACKEND}/Document/download/${data}/${type}`),
    getDocumentDownloadZip : () => `${process.env.REACT_APP_BACKEND}/Document/download`,
    postDocumentDownloadList : (body) => post(`${process.env.REACT_APP_BACKEND}/Document/export`, body),
    getDocumentDownloadHistory : (data, type) => get(`${process.env.REACT_APP_BACKEND}/Document/downloadHistory/${data}/${type}`),

    putDocumentBulkReview : (body) => putRaw(`${process.env.REACT_APP_BACKEND}/Document/bulkreview`, body),
    putDocumentBulkApproved : (body) => putRaw(`${process.env.REACT_APP_BACKEND}/Document/bulkapproved`, body),
    putDocumentBulkReject : (body) => putRaw(`${process.env.REACT_APP_BACKEND}/Document/bulkreject`, body),
    putDocumentBulkPublish : (body) => putRaw(`${process.env.REACT_APP_BACKEND}/Document/bulkpublish`, body),
    putDocumentBulkObsolete : (body) => putRaw(`${process.env.REACT_APP_BACKEND}/Document/bulkobsolete`, body),
}

export const DOCUMENT_CENTER_URL = {
    getDocumentCenterLista : (filter, config) => post(`${process.env.REACT_APP_BACKEND}/DocumentPublish/filter`, filter, config),

    getDocumentCenterProduct : (documentId) => get(`${process.env.REACT_APP_BACKEND}/DocumentPublish/getproductbydocument/${documentId}`),

    getDocumentCenterProducts : () => get(`${process.env.REACT_APP_BACKEND}/DocumentPublish/getproduct`),
    getDocumentCenterBusiness : () => get(`${process.env.REACT_APP_BACKEND}/DocumentPublish/getbusiness`),
    getDocumentCenterRegions : () => get(`${process.env.REACT_APP_BACKEND}/DocumentPublish/getregion`),

    getDocumentCenterDownloadZip : () => `${process.env.REACT_APP_BACKEND}/DocumentPublish/download/`,
    getDocumentCenterDownload : (documentId, type) => get(`${process.env.REACT_APP_BACKEND}/DocumentPublish/download/${documentId}/${type}`),
}

export const PRODUCT_URL = {
    getProductsList: () => get(`${process.env.REACT_APP_BACKEND}/Document/productsfilter`),
}

export const SNIPPETS_URL = {
    getSnippetsLista : (filter, config) => post(`${process.env.REACT_APP_BACKEND}/Snippet/filter`, filter, config),
    getSnippet : (data) => get(`${process.env.REACT_APP_BACKEND}/Snippet/${data}`),
    postSnippet : (body) => post(`${process.env.REACT_APP_BACKEND}/Snippet/`, body),
    putSnippet : (body) => put(`${process.env.REACT_APP_BACKEND}/Snippet/`, body),
    getSnippetHistory : (data) => get(`${process.env.REACT_APP_BACKEND}/Snippet/getHistory/${data}`),
    getSnippetHistoryList : (data, page) => get(`${process.env.REACT_APP_BACKEND}/Snippet/getHistory/${data}/10/${page}`),
    getSnippetAll : () => get(`${process.env.REACT_APP_BACKEND}/Snippet/getAll`),
    postSnippetDuplicate : (idSnippet) => post(`${process.env.REACT_APP_BACKEND}/Snippet/duplicate?idSnippet=${idSnippet}`),
    getSnippetProducts : (data) => get(`${process.env.REACT_APP_BACKEND}/Snippet/getproducts/${data}`),
    getSnippetSections : (data) => get(`${process.env.REACT_APP_BACKEND}/Snippet/getsections/${data}`),
    getSnippetPreview : (data) => get(`${process.env.REACT_APP_BACKEND}/Snippet/preview/${data}`),

    postSnippetDownloadList : (body) => post(`${process.env.REACT_APP_BACKEND}/Snippet/export`, body),
}


